import { Button } from '@quillbot/design-system';

import { createStyles, withStyles } from '@quillbot/design-system';

export default withStyles(() =>
  createStyles({
    root: {
      border: '1px solid #2f80ed',
      borderRadius: '20px',
      display: 'flex',
      padding: '1px 10px',
      alignItems: 'center',
      color: '#2f80ed',
    },
  })
)(Button);
